import { createFileRoute } from "@tanstack/react-router";
import { HomeContainer } from "@/features/home/layouts";

export const Route = createFileRoute("/$store/_layout/")({
	component: HomeContainer,
});
